import * as Immutable from 'seamless-immutable';
import {SET_PACKAGE_DEEPLINKING_FALSE, SHOW_NEW_ISSUE_MODAL} from '../actions';

const initialDeepLinkingReducerState = Immutable.from({
  // package deeplinking status is not 100% reliable since the mechanism in Routes that handles this state is not robust (e.g user just clicking in random before the package actually finishes loading the views/fetching some calls from the BE).
  // In case you need to rely on it for something important in a reliable way, you will need to find a better more robust solution for maintaining this state. Probably something that also depends on the consuming app.
  package: true,
  createForm: true
});
const deepLinkingReducer = (state = initialDeepLinkingReducerState, action) => {
  switch (action.type) {
    case SET_PACKAGE_DEEPLINKING_FALSE:
      return state.merge({package: false});
    case SHOW_NEW_ISSUE_MODAL:
      return state.createForm ? state.merge({createForm: state.package}) : state;
    default:
      return state;
  }
};

export default deepLinkingReducer;
